import React from "react";

function formatMetadataValue(value) {
  if (value === null || value === undefined) return "";
  if (typeof value === "string") return value;
  if (typeof value === "object") return JSON.stringify(value);
  return String(value);
}

export function FormattedDescription({ ticket, text }) {
  const rawText = [text, ticket?.ticket_description, ticket?.description].find(
    (value) => typeof value === "string" && value.trim(),
  )?.trim() || "";
  const parsedSummary =
    typeof ticket?.parsed_summary === "string"
      ? ticket.parsed_summary.trim()
      : "";
  const parsedMetadata =
    ticket?.parsed_metadata &&
    typeof ticket.parsed_metadata === "object" &&
    !Array.isArray(ticket.parsed_metadata)
      ? ticket.parsed_metadata
      : null;

  const inlineMetadata = [];
  const metadataPattern = /\*\*(.*?):\*\*\s*([^\n*]+)/g;
  let match;
  while ((match = metadataPattern.exec(rawText)) !== null) {
    inlineMetadata.push({ key: match[1].trim(), value: match[2].trim() });
  }

  const metaItems =
    parsedMetadata && Object.keys(parsedMetadata).length > 0
      ? Object.entries(parsedMetadata).map(([key, value]) => ({ key, value }))
      : inlineMetadata;
  const cleanSummary =
    parsedSummary ||
    rawText.replace(/\*\*(.*?):\*\*\s*([^\n*]+)/g, "").trim();

  if (!cleanSummary && metaItems.length === 0) return null;

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 8, marginTop: 4 }}>
      {cleanSummary && (
        <div
          style={{
            fontSize: 13,
            color: "#374151",
            lineHeight: 1.5,
            fontWeight: 500,
            background: "#F8FAFC",
            border: "1px solid #E2E8F0",
            borderRadius: 7,
            padding: "8px 12px",
          }}
        >
          {cleanSummary}
        </div>
      )}

      {metaItems.length > 0 && (
        <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
          {metaItems.map((item, idx) => (
            <div
              key={idx}
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 5,
                background: "#EFF6FF",
                border: "1px solid #DBEAFE",
                borderRadius: 6,
                padding: "3px 8px",
                fontSize: 11,
              }}
            >
              <span style={{ color: "#1D4ED8", fontWeight: 600 }}>{item.key}:</span>
              <span
                style={{
                  color: "#1E293B",
                  fontWeight: 600,
                  fontFamily: item.key.toLowerCase().includes("id") ? "monospace" : undefined,
                }}
              >
                {formatMetadataValue(item.value)}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default FormattedDescription;
